import {Product} from "./product";
import {PaymentMethodOption} from "./payment-method-option";
import {Discount} from "./discount";
import {FeatureItem} from "./feature-item";

class FootNote {
  title: string;
  content: string;

  constructor(footNoteData?) {
    if (footNoteData) {
      this.title = footNoteData.title;
      this.content = footNoteData.content;
    }
  }
}

export class ShopWindowItem {

  product: Product;
  paymentMethods: Array<PaymentMethodOption>;
  baseValue: number;
  baseValueStr: string;
  totalValue: number;
  totalValueString: string;
  totalValueBankBillet: number;
  discountedValue: number;
  appliedDiscounts: Array<Discount>;
  extraBalanceDiscount: Discount;
  discountsType: string;
  discountsSum: number;
  selected: boolean;
  disable: boolean;
  mapPaymentMethodAndDiscount: Array<any>;
  tdu: string;

  // Informações para montar o HTML
  cardBadge: string;
  cardTitle: string;
  featuredText: string;
  subtitle: string;
  economyValue: number;
  showInstallmentValue: boolean;
  showCashValue: boolean;
  showDiscounts: boolean;
  preferred: boolean;
  current: boolean;
  valueAndDiscountList: Array<string>;
  featureList: Array<FeatureItem>;
  monitoringFeatureList: Array<FeatureItem>;
  link: string;
  linkTitle: string;
  footnote: FootNote;
  buttonName: string;
  disableButton: boolean;
  backgroundColor: string;
  suggestion ?:{
    "triggerProductIdentifier": string,
    "suggestionProductIdentifier": string
    "discountIdentifier": string
    "discountPercent": number
    "discountedValue": number
  }
  extraBalanceValueSum: number;
  percentDiscount: number;

  integerPart: number;
  decimalPart: number;

  additionalProducts: Array<{
    title: string,
    subtitle: string,
    icon: string
  }> ;

  profitable: boolean;


  constructor(shopWindowItemData?) {
    if (shopWindowItemData) {
      this.product = new Product(shopWindowItemData.product);
      this.paymentMethods = shopWindowItemData.paymentMethods.map(paymentMethod => new PaymentMethodOption(paymentMethod));
      this.baseValue = shopWindowItemData.baseValue;
      this.baseValueStr = this.formatPrice(shopWindowItemData.baseValue);
      this.totalValue = shopWindowItemData.totalValue;
      this.totalValueString = String(shopWindowItemData.totalValue).replace(".", ",");
      this.discountedValue = Number((shopWindowItemData.baseValue - shopWindowItemData.totalValue).toFixed(2));
      this.totalValueBankBillet = shopWindowItemData.totalValueBankBillet;
      this.disable = shopWindowItemData.disable;
      this.discountsSum = shopWindowItemData.baseValue;
      this.extraBalanceValueSum=0;
      this.mapPaymentMethodAndDiscount = shopWindowItemData.mapPaymentMethodAndDiscount;
      this.tdu = shopWindowItemData.tdu || null;
      this.suggestion = shopWindowItemData.suggestion || null;

      if (shopWindowItemData.appliedDiscounts && shopWindowItemData.appliedDiscounts.length) {
        this.appliedDiscounts = shopWindowItemData.appliedDiscounts.map(discount => {
          if(discount.type === "EXTRA_BALANCE"){
            let productValue = discount.productValue;
            if (discount.deal.includes("R$")) {
              discount.discountAmount = Number(discount.deal.replace("R$", "").replace(" ", ""));
            } else {
              let rate = Number(discount.deal.replace("%", "").replace(" ", ""));
              discount.discountAmount =  Number((productValue * rate) / 100);
            }
            this.extraBalanceValueSum += discount.discountAmount;
            // this.discountsSum = (discount.discountAmount + this.baseValue).toFixed(0);
          }
          return new Discount(discount);
        });
        this.extraBalanceDiscount = this.appliedDiscounts.find(discount => discount.type === "EXTRA_BALANCE");
        this.discountsType = "NON_EXTRA_BALANCE_ONLY";
        if(Boolean(this.extraBalanceDiscount)){
            this.discountsType = this.getDiscountsType(this.appliedDiscounts, this.extraBalanceDiscount);
        }
      }

      if (this.discountedValue){
        this.percentDiscount = Math.round((this.discountedValue / this.baseValue) * 100 * 100) / 100;
      }
      this.current = shopWindowItemData.current;

      // HTML Data
      this.cardBadge = shopWindowItemData.cardBadge;
      this.cardTitle = shopWindowItemData.cardTitle;
      this.featuredText = shopWindowItemData.featuredText;
      this.subtitle = shopWindowItemData.subtitle;
      this.economyValue = shopWindowItemData.economyValue;
      this.showInstallmentValue = shopWindowItemData.showInstallmentValue;
      this.showCashValue = shopWindowItemData.showCashValue;
      this.showDiscounts = shopWindowItemData.showDiscounts;
      this.preferred = shopWindowItemData.preferred;
      this.valueAndDiscountList = shopWindowItemData.valueAndDiscountList;
      this.featureList = shopWindowItemData.featureList ? shopWindowItemData.featureList.map(feature => new FeatureItem(feature)) : null;
      this.link = shopWindowItemData.link;
      this.linkTitle = shopWindowItemData.linkTitle;
      this.footnote = shopWindowItemData.footnote ? new FootNote(shopWindowItemData.footnote) : null;
      this.buttonName = shopWindowItemData.buttonName;
      this.disableButton = shopWindowItemData.disableButton !== null ? shopWindowItemData.disableButton : false;

      this.integerPart = Math.floor(this.totalValue);
      this.decimalPart = Number((this.totalValue % 1).toFixed(2).substring(2));

      this.additionalProducts = shopWindowItemData.additionalProducts || null;
    }
  }

  getDiscountsType(discounts: Array<Discount>, extraBalanceDiscount: Discount){
      var discountsType;
      if(extraBalanceDiscount && discounts.length === 1) discountsType = "EXTRA_BALANCE_ONLY";
      if(extraBalanceDiscount && discounts.length > 1) discountsType = "BOTH";

      return discountsType;
  }
  formatPrice(price) {
    if (price % 1 === 0) {
      return price.toFixed(0);
    } else {
      return price.toFixed(2).replace('.', ',');
    }
  }
}
